import { render, staticRenderFns } from "./detallePedido.vue?vue&type=template&id=a8ce1012&scoped=true&"
import script from "./detallePedido.vue?vue&type=script&lang=js&"
export * from "./detallePedido.vue?vue&type=script&lang=js&"
import style0 from "./detallePedido.vue?vue&type=style&index=0&id=a8ce1012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ce1012",
  null
  
)

export default component.exports